import React from "react";
import styled from "styled-components";

const LargeContainer = ({
  children,
  bg,
  height,
  valign,
  halign,
  style,
  className,
}) => {
  return (
    <Container
      bg={bg}
      height={height}
      valign={valign}
      halign={halign}
      style={style}
      className={className}
    >
      {children}
    </Container>
  );
};
const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: ${(props) => props.valign};
  justify-content: ${(props) => props.halign};
  background: ${(props) => props.bg};
  height: ${(props) => props.height};
`;
export default LargeContainer;
